module.exports = __webpack_public_path__ + "img/dev-ribbon.96519e20.png";